export default __webpack_public_path__ + "static/media/B145.490ec5e6.png";